import React from 'react';
import { Avatar, AvatarGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import people from '../../assets/table-imgs/people.png';
import pdf from '../../assets/table-imgs/pdf.png';
import doc from '../../assets/table-imgs/doc.png';
import todo from '../../assets/table-imgs/todo.png';
import './global-table.scss';

interface Props {
    tableData: any;
    theadData: any;
    getSelectedId?: any;
    type: string;
    role?: string | any;
}

const GlobalTable = (props: Props) => {
    const { tableData, theadData, getSelectedId, type, role } = props;

    const roles: string[] = ['employee', 'manager', 'admin'];

    const showCheckBoxesTo: string[] = ['my files', 'company files', 'e-sign files',
        'employee directory', 'recruitment', 'employee time off', 'employee files',
        'confidential files', 'manage task', 'organisation report', 'employee change',
        'address history', 'audit list', 'changes', 'attendance', 'salalry', 'general'];


    // for checkbox display
    // const checkboxValidation = ['employee directory', 'recruitment', 'my files', 'employee files', 'company files', 'confidential files', 'e-sign files', 'manage task'];
    const checkboxval = showCheckBoxesTo.includes(type) ? true : false;

    // for single image
    const userImageValidation = ['avatar', 'reportingManager', 'approver', 'reportsTo', 'approvedBy', 'employee', 'uploadedBy', 'sharedBy', 'requestedBy', 'assignee'];
    // for multiple images
    const multipleUserImages = ['sharedWith'];


    const checkValidateFunv = (key: string, content: any, data: any) => {

        // for signle image condition
        if (userImageValidation.includes(key)) {
            return <div className='img-circle'><img src={content} alt='user' /></div>
        }
        // for multiple images condition
        if (multipleUserImages.includes(key)) {
            return <AvatarGroup max={3} sx={{ justifyContent: 'flex-end', height: '40px', width: '40px' }}>
                {multipleUserImages.map(multiple => data[multiple].map((img: string, i: number) => <Avatar key={i} alt='users' src={img} />))}
            </AvatarGroup>
        }
        // for tags in selected tables
        if (key === 'tags' && checkboxval) {
            return <div className='tags d-flex align-center'>
                {data?.tags.map((tag: string) => <span key={tag} className='tag fw-500'>{tag}</span>)}
            </div>
        }
        // for time off table
        if (key === 'requestedPeriod' && (type === 'time off' || type === 'employee time off')) {
            return <span className='requested-period text-center'>{content}</span>
        }
        // for status background color in tables 
        if (key === 'status' || key === 'benefitStatus') {
            const primaryColor = ['new', 'eligible'];
            const warningColor = ['pending', 'to do'];
            const successColor = ['approved', 'done', 'signed', 'completed', 'enrolled'];
            const dangerColor = ['declined', 'overdue', 'rejected', 'cancelled'];
            return <span className={`tile ${warningColor.includes(content) ? 'warning' : successColor.includes(content) ? 'success'
                : dangerColor.includes(content) ? 'danger' : primaryColor.includes(content) ? 'primary' : 'default-color'}`}
            >{content}</span>
        }

        // for status outline color and show doc file icon in tables
        if (key === 'evaluation' && type === 'team evaluation') {
            return content === 'completed' ? <img src={pdf} alt='pdf' /> :
                <span className={`tile-outline ${content === 'start' ? 'primary' : content === 'continue' ? 'warning' : 'default-color'}`}>
                    {content}</span>
        }

        // for recruitment candidate field
        if (key === 'candidates' && type === 'recruitment') {
            return <div className='d-flex align-center people'><img src={people} alt='people' /><p>{content}</p></div>
        }

        // for view and preview icon
        if (key === 'view' || key === 'preview' && type === 'team evaluation') {
            return <VisibilityIcon sx={{ color: '#4C0027' }} />
        }

        // for detail icon
        if (key === 'detail' && type === 'my task list') {
            return <img src={todo} alt='to do' />
        }

        // for time off attachment icon
        if (key === 'attachment') {
            if (type === 'time off' || type === 'employee time off') {
                return <div className='d-flex align-center'><img className='doc-img' src={doc} alt='doc' /><img src={pdf} alt='pdf' /></div>
            }
            else { return <img src={pdf} alt='pdf' /> }
        }


        // return default text value 
        else {
            return <p>{content}</p>
        }
    }

    return (

        <TableContainer className='table-wrapper'>
            <Table className='table'>

                <TableHead className='table-head'>
                    <TableRow className='table-row'>
                        {(roles.includes(role) && showCheckBoxesTo.includes(type)) && <TableCell className='table-detail text-capitalize'><input className='table-checkbox' type='checkbox' /></TableCell>}
                        {theadData.map((th: any) => <TableCell className='table-detail text-capitalize' key={th}><p>{th}</p></TableCell>)}
                    </TableRow>
                </TableHead>

                <TableBody className='table-body'>
                    {
                        tableData.map((data: any) => <TableRow key={data.id} className='table-row' onClick={() => getSelectedId(data.id, type,data)}>

                            {(roles.includes(role) && showCheckBoxesTo.includes(type)) && <TableCell className='table-detail text-capitalize'><input className='table-checkbox' type='checkbox' /></TableCell>}

                            {Object.keys(data).map(td => data.id === data[td] ? null : <TableCell key={td} className='table-detail text-capitalize'>
                                {checkValidateFunv(td, data[td], data)}
                            </TableCell>)}

                        </TableRow>)
                    }
                </TableBody>

            </Table>
        </TableContainer>
    )
}

export default GlobalTable